export const LOAD_OPEN_TOTAL = "LOAD_OPEN_TOTAL";
export const LOAD_OPEN_TOTAL_DASHBOARD_SAGA = "LOAD_OPEN_TOTAL_DASHBOARD_SAGA";
export const LOAD_OPEN_HOT = "LOAD_OPEN_HOT";
export const LOAD_OPEN_HOT_DASHBOARD_SAGA = "LOAD_OPEN_HOT_DASHBOARD_SAGA";
export const LOAD_OPEN_WARM = "LOAD_OPEN_WARM";
export const LOAD_OPEN_WARM_DASHBOARD_SAGA = "LOAD_OPEN_WARM_DASHBOARD_SAGA";
export const LOAD_OPEN_COLD = "LOAD_OPEN_COLD";
export const LOAD_OPEN_COLD_DASHBOARD_SAGA = "LOAD_OPEN_COLD_DASHBOARD_SAGA";

export const LOAD_READY_PICKING_TOTAL = "LOAD_READY_PICKING_TOTAL";
export const LOAD_READY_PICKING_TOTAL_DASHBOARD_SAGA = "LOAD_READY_PICKING_TOTAL_DASHBOARD_SAGA";
export const LOAD_READY_PICKING_HOT = "LOAD_READY_PICKING_HOT";
export const LOAD_READY_PICKING_HOT_DASHBOARD_SAGA = "LOAD_READY_PICKING_HOT_DASHBOARD_SAGA";
export const LOAD_READY_PICKING_WARM = "LOAD_READY_PICKING_WARM";
export const LOAD_READY_PICKING_WARM_DASHBOARD_SAGA = "LOAD_READY_PICKING_WARM_DASHBOARD_SAGA";
export const LOAD_READY_PICKING_COLD = "LOAD_READY_PICKING_COLD";
export const LOAD_READY_PICKING_COLD_DASHBOARD_SAGA = "LOAD_READY_PICKING_COLD_DASHBOARD_SAGA";

export const LOAD_PACKED_TOTAL = "LOAD_PACKED_TOTAL";
export const LOAD_PACKED_TOTAL_DASHBOARD_SAGA = "LOAD_PACKED_TOTAL_DASHBOARD_SAGA";
export const LOAD_PACKED_HOT = "LOAD_PACKED_HOT";
export const LOAD_PACKED_HOT_DASHBOARD_SAGA = "LOAD_PACKED_HOT_DASHBOARD_SAGA";
export const LOAD_PACKED_WARM = "LOAD_PACKED_WARM";
export const LOAD_PACKED_WARM_DASHBOARD_SAGA = "LOAD_PACKED_WARM_DASHBOARD_SAGA";
export const LOAD_PACKED_COLD = "LOAD_PACKED_COLD";
export const LOAD_PACKED_COLD_DASHBOARD_SAGA = "LOAD_PACKED_COLD_DASHBOARD_SAGA";

export const LOAD_SHIPPED_TOTAL = "LOAD_SHIPPED_TOTAL";
export const LOAD_SHIPPED_TOTAL_DASHBOARD_SAGA = "LOAD_SHIPPED_TOTAL_DASHBOARD_SAGA";
export const LOAD_SHIPPED_HOT = "LOAD_SHIPPED_HOT";
export const LOAD_SHIPPED_HOT_DASHBOARD_SAGA = "LOAD_SHIPPED_HOT_DASHBOARD_SAGA";
export const LOAD_SHIPPED_WARM = "LOAD_SHIPPED_WARM";
export const LOAD_SHIPPED_WARM_DASHBOARD_SAGA = "LOAD_SHIPPED_WARM_DASHBOARD_SAGA";
export const LOAD_SHIPPED_COLD = "LOAD_SHIPPED_COLD";
export const LOAD_SHIPPED_COLD_DASHBOARD_SAGA = "LOAD_SHIPPED_COLD_DASHBOARD_SAGA";

export const UPDATE_IS_LOADING_SLA = "UPDATE_IS_LOADING_SLA";
export const UPDATE_IS_LOADING_SLA_SAGA = "UPDATE_IS_LOADING_SLA_SAGA";

export interface ILoadOpenTotalActionSaga {
  readonly type: typeof LOAD_OPEN_TOTAL_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadOpenTotalDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadOpenTotalActionSaga => {
  return {
    type: LOAD_OPEN_TOTAL_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};


export interface ILoadOpenHotActionSaga {
  readonly type: typeof LOAD_OPEN_HOT_DASHBOARD_SAGA;
  fdcFlag: boolean
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadOpenHotDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadOpenHotActionSaga => {
  return {
    type: LOAD_OPEN_HOT_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};


export interface ILoadOpenWarmActionSaga {
  readonly type: typeof LOAD_OPEN_WARM_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadOpenWarmDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadOpenWarmActionSaga => {
  return {
    type: LOAD_OPEN_WARM_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadOpenColdActionSaga {
  readonly type: typeof LOAD_OPEN_COLD_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadOpenColdDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadOpenColdActionSaga => {
  return {
    type: LOAD_OPEN_COLD_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};


export interface ILoadReadyPickingTotalActionSaga {
  readonly type: typeof LOAD_READY_PICKING_TOTAL_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadReadyPickingTotalDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadReadyPickingTotalActionSaga => {
  return {
    type: LOAD_READY_PICKING_TOTAL_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadReadyPickingHotActionSaga {
  readonly type: typeof LOAD_READY_PICKING_HOT_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadReadyPickingHotDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadReadyPickingHotActionSaga => {
  return {
    type: LOAD_READY_PICKING_HOT_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadReadyPickingWarmActionSaga {
  readonly type: typeof LOAD_READY_PICKING_WARM_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadReadyPickingWarmDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadReadyPickingWarmActionSaga => {
  return {
    type: LOAD_READY_PICKING_WARM_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};


export interface ILoadReadyPickingColdActionSaga {
  readonly type: typeof LOAD_READY_PICKING_COLD_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadReadyPickingColdDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadReadyPickingColdActionSaga => {
  return {
    type: LOAD_READY_PICKING_COLD_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};


export interface ILoadPackedTotalActionSaga {
  readonly type: typeof LOAD_PACKED_TOTAL_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadPackedTotalDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadPackedTotalActionSaga => {
  return {
    type: LOAD_PACKED_TOTAL_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadPackedHotActionSaga {
  readonly type: typeof LOAD_PACKED_HOT_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadPackedHotDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadPackedHotActionSaga => {
  return {
    type: LOAD_PACKED_HOT_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadPackedWarmActionSaga {
  readonly type: typeof LOAD_PACKED_WARM_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadPackedWarmDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadPackedWarmActionSaga => {
  return {
    type: LOAD_PACKED_WARM_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};

export interface ILoadPackedColdActionSaga {
  readonly type: typeof LOAD_PACKED_COLD_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadPackedColdDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadPackedColdActionSaga => {
  return {
    type: LOAD_PACKED_COLD_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};

export interface ILoadShippedTotalActionSaga {
  readonly type: typeof LOAD_SHIPPED_TOTAL_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadShippedTotalDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadShippedTotalActionSaga => {
  return {
    type: LOAD_SHIPPED_TOTAL_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadShippedHotActionSaga {
  readonly type: typeof LOAD_SHIPPED_HOT_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadShippedHotDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadShippedHotActionSaga => {
  return {
    type: LOAD_SHIPPED_HOT_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadShippedWarmActionSaga {
  readonly type: typeof LOAD_SHIPPED_WARM_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadShippedWarmDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadShippedWarmActionSaga => {
  return {
    type: LOAD_SHIPPED_WARM_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};
export interface ILoadShippedColdActionSaga {
  readonly type: typeof LOAD_SHIPPED_COLD_DASHBOARD_SAGA;
  fdcFlag: boolean;
  status: string;
  ergency: string;
  page: number;
  size: number;
  sort: string;
  orderId: string;
}
export const loadShippedColdDashboardPropsSaga = (
  fdcFlag = false,
  status = "",
  sort = "",
  ergency = "",
  page = 0,
  size = 25,
  orderId = "",
): ILoadShippedColdActionSaga => {
  return {
    type: LOAD_SHIPPED_COLD_DASHBOARD_SAGA,
    fdcFlag: fdcFlag,
    status: status,
    ergency: ergency,
    page: page,
    size: size,
    sort: sort,
    orderId: orderId,
  };
};